export default __webpack_public_path__ + "static/media/logo_observatorio.68d58d7b.png";